import gql from 'graphql-tag';

export const GET_PROJECTS_QUERY = gql`
    query Projects($limit: Int, $offset: Int, $year: [QueryArgument!], $sector: [QueryArgument!], $search: String) {
        entries: projectsEntries(
            limit: $limit,
            offset: $offset,
            year: $year,
            sector: $sector,
            search: $search
        ) {
            ... on projects_Entry {
                id
                url
                title
                location
                featuredImageWide: projectFeaturedImage(limit: 1) @transform(width: 970, height: 728, format: "webp") {
                    url
                    srcset(sizes: ["1x", "2x", "3x"])
                }
                featuredImageNarrow: projectFeaturedImage(limit: 1) @transform(width: 470, height: 728, format: "webp") {
                    url
                    srcset(sizes: ["1x", "2x", "3x"])
                }
            }
        }
    }
`;
